function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 5C3.6125 5 2.5 6.1125 2.5 7.5V22.5C2.5 23.163 2.76339 23.7989 3.23223 24.2678C3.70107 24.7366 4.33696 25 5 25H25C25.663 25 26.2989 24.7366 26.7678 24.2678C27.2366 23.7989 27.5 23.163 27.5 22.5V7.5C27.5 6.83696 27.2366 6.20107 26.7678 5.73223C26.2989 5.26339 25.663 5 25 5H5ZM5 7.5H13.75V10.1625C11.55 10.7375 10 12.725 10 15C10.003 16.1073 10.3725 17.1824 11.0509 18.0576C11.7293 18.9327 12.6784 19.5586 13.75 19.8375V22.5H5V20H8.75V10H5V7.5ZM16.25 7.5H25V10H21.25V20H25V22.5H16.25V19.8375C18.45 19.2625 20 17.275 20 15C19.997 13.8927 19.6275 12.8176 18.9491 11.9424C18.2707 11.0673 17.3216 10.4414 16.25 10.1625V7.5ZM5 12.5H6.25V17.5H5V12.5ZM23.75 12.5H25V17.5H23.75V12.5ZM16.25 12.8375C17.025 13.2875 17.5 14.1125 17.5 15C17.5 15.8875 17.025 16.7125 16.25 17.1625V12.8375ZM13.75 12.8375V17.1625C12.975 16.7125 12.5 15.8875 12.5 15C12.5 14.1125 12.975 13.2875 13.75 12.8375Z",
  fill: "current"
});

function SvgPitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/pitch.b3b86ce2.svg";
export { ForwardRef as ReactComponent };